"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFundingMechanics = void 0;
var mechanics_1 = require("./mechanics");
Object.defineProperty(exports, "getFundingMechanics", { enumerable: true, get: function () { return mechanics_1.getFundingMechanics; } });
//# sourceMappingURL=index.js.map